import moment from "moment";
import { dateConfig, timeConfig } from "../config";
import { endOfWeek, startOfWeek } from "date-fns";
import { SET_EMPTY } from "../config";

/**
 * Function to set user token in browser storage to persist authentication across user sessions.
 * @param {string} token as in signed in user's uid
 */
export const setAuthorizationToken = (token) => {
  localStorage.setItem("imtimeToken", token);
};

/**
 * Function to return user token from browser storage
 * @returns {string} token as in user's uid
 */
export const getAuthorizationToken = () => {
  return localStorage.getItem("imtimeToken");
};

/**
 * Function to remove user token from browser storage.
 */
export const removeAuthorizationToken = () => {
  localStorage.removeItem("imtimeToken");
};

export const isEmptyObject = (obj) => {
  return obj ? Object.keys(obj).length === 0 : true;
};

export const getDistrictsByCountry = (
  districtOptions,
  appConfig,
  country,
  defaultDistrict
) => {
  const workerCountry = country.toLowerCase();
  if (appConfig.locations[workerCountry]) {
    districtOptions = appConfig.locations[workerCountry];
  }
  districtOptions = defaultDistrict.concat(districtOptions);
  // console.log(districtOptions)
  return districtOptions;
};

export const getStartOfWeek = (date) => {
  return moment(startOfWeek(date)).format(dateConfig.format6);
};

export const getEndOfWeek = (date) => {
  // return moment(new Date(date)).add(7, "days").format(dateConfig.format6);
  return moment(endOfWeek(date)).format(dateConfig.format6);
};

export const isDateValid = (date) => {
  let m = moment(date);
  return m.isValid();
};

// show customer site text field if building value is customer_site
// hide customer site field if building value is not customer_site and set text field value is empty
export const customerSiteAvailability = (
  building,
  customerSite,
  CUSTOMER_SITE,
  setCustomerSiteVisible,
  setCustomerSite,
  SET_EMPTY
) => {
  if (building === CUSTOMER_SITE) {
    setCustomerSiteVisible(true);
  } else {
    setCustomerSiteVisible(false);
    setCustomerSite(SET_EMPTY);
  }
};

//Sets the default value for the dropdowns
export const setDefaultValue = (
  dropDownOptions,
  lastPunchValue,
  defaultValue,
  setValue
) => {
  if (lastPunchValue !== null) {
    const i = dropDownOptions.find((item) => lastPunchValue === item.value);
    if (i && i.label) {
      setValue(lastPunchValue);
    } else {
      setValue(defaultValue);
    }
  } else {
    setValue(defaultValue);
  }
};

//Validates the dropdown values.
export const validateEntries = (
  district,
  building,
  jobFamily,
  activityGroup
) => {
  if (
    district !== -1 &&
    building !== -1 &&
    jobFamily !== -1 &&
    activityGroup !== -1
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * Calculates the time duration between inLocalTS and outLocalTS in hrs
 * @param {object} - record
 * @return: Number - hour duration in hours
 */
export const getDurationInHours = (record) => {
  let hours = 0;
  if (
    record.inLocalTS &&
    record.inLocalTS !== "" &&
    record.outLocalTS &&
    record.outLocalTS !== ""
  ) {
    const end = moment(record.outLocalTS && record.outLocalTS.substr(0, 16));
    const start = moment(record.inLocalTS && record.inLocalTS.substr(0, 16));
    const diff = moment.duration(end.diff(start));
    hours = diff.asHours();
  }
  return hours.toFixed(2);
};

export const toggleDisableException = (
  exceptionDate,
  exceptionTime,
  setDisableException,
  setDisableForTime,
  setHelperTextForFutureTime,
  lastPunchClock
) => {
  let selectedDate = moment(exceptionDate).format(dateConfig.format6);
  let maxDate = moment(new Date()).format(dateConfig.format7);
  let time = moment(exceptionTime).format(timeConfig.format3);
  let userSelectedDateTime = moment(selectedDate + " " + time).format(
    dateConfig.format7
  );
  if (
    exceptionTime != null &&
    !isNaN(exceptionDate) &&
    !isNaN(exceptionTime.getTime())
  ) {
    if (userSelectedDateTime > maxDate) {
      //if time is future time
      setHelperTextForFutureTime("You cannot select future Time");
      setDisableForTime(true);
      setDisableException(true);
    } else if (selectedDate < lastPunchClock) {
      //if time is before the last clockin or clockout
      setHelperTextForFutureTime(SET_EMPTY);
      setDisableException(true);
      setDisableForTime(false);
    } else {
      //if everything is OK
      setHelperTextForFutureTime(SET_EMPTY);
      setDisableException(false);
      setDisableForTime(false);
    }
  } else if (!isNaN(exceptionDate)) {
    //if it is an invalid time
    setHelperTextForFutureTime(SET_EMPTY);
    setDisableException(true);
    setDisableForTime(true);
  }
};

export const getEmployeeNameWithID = (worker) => {
  if (worker.workerId != -1)
    return (
      worker.firstName + " " + worker.lastName + " (" + worker.workerId + ")"
    );
  else return worker.firstName + " " + worker.lastName;
};

export const properCase = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const properCamelCase = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();
  const txtArr = str.split(/[. \-_]/);
  if (txtArr && txtArr.length > 1) {
    return (
      txtArr[0].charAt(0).toLowerCase() +
      txtArr[0].substring(1) +
      txtArr[1].charAt(0).toUpperCase() +
      txtArr[1].substring(1)
    );
  }
  return str.charAt(0).toLowerCase() + str.substring(1);
};
export const properCamelCaseNew = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();
  str = str.toLowerCase();
  const txtArr = str.split(/[. \-_]/);
  let finalString = "";
  if (txtArr && txtArr.length > 1) {
    for (let i = 0; i < txtArr.length; i++) {
      let eachWord = txtArr[i];
      if (i != 0) {
        eachWord = eachWord.charAt(0).toUpperCase() + eachWord.substring(1);
      }
      finalString += eachWord;
    }
    return finalString;
  }
  return str.charAt(0).toLowerCase() + str.substring(1);
};

export const getFullName = (firstName, lastName, preferredName) => {
  let fullName = "";
  fullName = preferredName
    ? preferredName
    : (firstName ? firstName : " ") + " " + (lastName ? lastName : " ");
  if (fullName) {
    fullName = fullName.trim();
  }
  return fullName;
};

export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const getProjectInfoEntryType = (jobFamily, jobFamilyOptions) => {
  let projInfoEntryType;
  jobFamilyOptions.forEach((jobFamObject) => {
    if (jobFamObject.value === jobFamily) {
      projInfoEntryType = jobFamObject.projectInfoEntryType;
    }
  });

  return projInfoEntryType;
};

export const jobTypeITContractor = "IT Contractor";
